function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 16H22V18H2V16ZM3.15 11.95L4 10.47L4.85 11.95L6.15 11.2L5.3 9.72H7V8.22H5.3L6.15 6.75L4.85 6L4 7.47L3.15 6L1.85 6.75L2.7 8.22H1V9.72H2.7L1.85 11.2L3.15 11.95ZM9.85 11.2L11.15 11.95L12 10.47L12.85 11.95L14.15 11.2L13.3 9.72H15V8.22H13.3L14.15 6.75L12.85 6L12 7.47L11.15 6L9.85 6.75L10.7 8.22H9V9.72H10.7L9.85 11.2ZM23 8.22H21.3L22.15 6.75L20.85 6L20 7.47L19.15 6L17.85 6.75L18.7 8.22H17V9.72H18.7L17.85 11.2L19.15 11.95L20 10.47L20.85 11.95L22.15 11.2L21.3 9.72H23V8.22Z",
  fill: "currentColor"
});

var SvgIcUserMenuPassword = function SvgIcUserMenuPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcUserMenuPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-user-menu-password.d5b64623.svg";
export { ForwardRef as ReactComponent };